import React from 'react';
// import RouterGuard from '@/components/RouterGuard'
import type { Route } from '@/types/common';

const MyDiamond = React.lazy(() => import('@/pages/Withdraw/MyDiamond'))
const Withdraw = React.lazy(() => import('@/pages/Withdraw'))
const AddWithdrawAccount = React.lazy(() => import('@/pages/Withdraw/addMethod'))
const WithdrawOrder = React.lazy(() => import('@/pages/Withdraw/order'))
const SelectRole = React.lazy(() => import('@/pages/Withdraw/selectRole')); // 选择角色页面

const withdrawRoutes: Route[] = [
  {
    path: '/select-role',
    name: 'SelectRole',
    title: '选择角色',
    element: <SelectRole />,
  },
  {
    path: '/my-diamond',
    name: 'MyDiamond',
    title: '我的钻石',
    meta: {},
    element: <MyDiamond />,
  },
  {
    path: '/withdraw',
    name: 'Withdraw',
    title: '提现',
    meta: {},
    element: <Withdraw />,
  },
    {
    path: '/withdraw/add-method',
    name: 'AddWithdrawAccount',
    title: '添加提现方式',
    element: (<AddWithdrawAccount />),
  },
  {
    path: '/withdraw/order',
    name: 'WithdrawOrder',
    title: '提现订单',
    element: (<WithdrawOrder />),
  },
];

export default withdrawRoutes;